import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './MapStatusView.module.scss';
export function MapStatusView(props) {
    const { mapStatus } = props;
    const { t: texts } = useLocaleKeys('integrations.mapStatusView');
    let element;
    switch(mapStatus){
        case 'mapped':
            element = /*#__PURE__*/ _jsx("div", {
                className: styles.mapped,
                children: texts.mapped()
            });
            break;
        case 'notMapped':
            element = /*#__PURE__*/ _jsx("div", {
                className: styles.notMapped,
                children: texts.notMapped()
            });
            break;
        case 'failedToMap':
            element = /*#__PURE__*/ _jsx("div", {
                className: styles.failedToMap,
                children: texts.failedToMap()
            });
            break;
        case 'mapping':
            element = /*#__PURE__*/ _jsx(Spinner, {
                testId: "map-spinner",
                size: 32
            });
            break;
        default:
            element = null;
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": "map-status",
        children: element
    });
}
